import { initializeApp } from "firebase/app";
import { getMessaging, getToken,deleteToken } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyB5nbGUze0OxbUqMnaeQ4y522rCul0NE0c",
    authDomain: "community-buddy.firebaseapp.com",
    projectId: "community-buddy",
    storageBucket: "community-buddy.firebasestorage.app",
    messagingSenderId: "488178617633",
    appId: "1:488178617633:web:df98b08a188bd71850c260"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging and get a reference to the service
export const messaging = getMessaging(app);


export const generateToken = async () => {

    try {


        const permission = await Notification.requestPermission();
        if (permission === "granted") {
            await deleteToken(messaging);
            const token = await getToken(messaging, {
                vapidKey: "BCiNyKKIr4ZgavNK6P_CjXvsDnhWv2DC7jp6QibXe6YKoVUjlzntCYvs7cDgFw9TZCUWcjCClC1vnAuvnsDFkTI",
            })
            return token;
        } else if (permission === "denied") {
            alert("Please allow notifications in your browser settings to receive updates.");
            return null;
        } else {

            return null;
        }
    } catch (error) {
        console.error("FCM token generation error:", error);
        return "";
    }

}


// if ('serviceWorker' in navigator) {
//     navigator.serviceWorker
//         .register('/firebase-messaging-sw.js')
//         .then((registration) => {
//             console.log('Service Worker registered:', registration);
//         })
//         .catch((err) => {
//             console.error('Service Worker registration failed:', err);
//         });
// }


// export const generateToken = async () => {
//     try {
//         const permission = await Notification.requestPermission();
//         if (permission !== "granted") {
//             return "";
//         }

//         const registration = await navigator?.serviceWorker?.getRegistration('/firebase-messaging-sw.js');

//         if (!registration) {
//             console.error('No service worker found');
//             return "";
//         }

//         const token = await getToken(messaging, {
//             vapidKey: "BCiNyKKIr4ZgavNK6P_CjXvsDnhWv2DC7jp6QibXe6YKoVUjlzntCYvs7cDgFw9TZCUWcjCClC1vnAuvnsDFkTI",
//             serviceWorkerRegistration: registration,
//         });

//         return token || "";
//     } catch (error) {
//         console.error("FCM token generation error:", error);
//         return "";
//     }
// };